import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { formatCounterAmount } from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'

import type AllowanceIncidence from 'modules/timeoff/store/models/AllowanceIncidence'

interface IncidenceProps {
  allowanceIncidence: AllowanceIncidence
  isHourlyFixedBalance: boolean
}

const Incidence = ({ allowanceIncidence, isHourlyFixedBalance }: IncidenceProps) => {
  const days = allowanceIncidence.units / 100
  const sign = days > 0 ? '+' : '-'

  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal>{i18n.t('time_off.allowance_tooltip.holiday')}</Text.Normal>
        <Text.Normal>{`${sign} ${formatCounterAmount(
          Math.abs(days),
          isHourlyFixedBalance
        )}`}</Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="flexStart">
        <Text.Normal size="200">{allowanceIncidence.attributes.description}</Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(Incidence)
